import { Form } from "@redriver/cinnamon-mui";
import { countriesLookup } from "modules/lookups";

const CountryDropdown = (props) => (
  <Form.Dropdown lookup={countriesLookup} search {...props} />
);

export default CountryDropdown;
